//Custom components
import type { IType } from '@/api/Rover/types';
import { transformProjectTypeChartDataSets } from '@/utils';
import Card from '../../../UI/Card/index.tsx';
import PieChart from '../../../UI/Charts/PieChart';

export interface BreakdownProps {
  title: string;
  breakdownDeal: IType[];
}

export default function BreakdownDealTypeWidget(props: BreakdownProps) {
  const { title, breakdownDeal } = props;

  const dealTypeLabels = breakdownDeal?.map((data: IType) => data?.dealType);

  const projectsByDealType = breakdownDeal?.map((data: IType) => {
    return {
      type: data?.constructionType,
      count: data?._count?.dealType,
    };
  });

  const totalDealType = breakdownDeal?.reduce((acc: number, data: IType) => {
    return acc + data?._count?.dealType;
  }, 0);

  return (
    <Card title={title}>
      <div className='relative p-5 h-80'>
        <div className='absolute px-5 text-center'>
          <h3 className='text-gray-500 font-bold'>Total Projects</h3>
          <h1 className='m-0'>{totalDealType}</h1>
        </div>
        <div className='md:w-7/8 xl:w-full h-full'>
          <PieChart
            labels={dealTypeLabels}
            datasets={transformProjectTypeChartDataSets(projectsByDealType)}
            chartTitle='Total Project Types'
          />
        </div>
      </div>
    </Card>
  );
}
